import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AudienceTargetingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AudienceTargeting",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.46 13.07c-1.08-4.21-4.39-7.5-8.61-8.55a3 3 0 0 0-3.48-2.44 3 3 0 0 0-2.44 2.44 11.89 11.89 0 0 0-8.45 8.56 2.915 2.915 0 0 0-2.44 3.32 2.92 2.92 0 0 0 2.44 2.44c1.04 4.21 4.28 7.52 8.47 8.64a3 3 0 0 0 3.48 2.44 3 3 0 0 0 2.44-2.44c4.24-1.07 7.55-4.37 8.62-8.61 1.59-.22 2.71-1.7 2.48-3.29a2.906 2.906 0 0 0-2.48-2.48zM18.5 25.66a3.03 3.03 0 0 0-2-1.45V21.5c0-.16-.14-.29-.31-.29h-.72a.29.29 0 0 0-.29.29v2.73c-.8.18-1.48.7-1.88 1.42a9.92 9.92 0 0 1-6.95-7.04 2.95 2.95 0 0 0 1.49-1.74h2.66c.17 0 .31-.14.31-.31v-.72c0-.16-.14-.29-.31-.29H7.95c-.15-.93-.73-1.72-1.57-2.15a9.95 9.95 0 0 1 6.92-6.96c.41.7 1.09 1.21 1.89 1.39v2.99c0 .16.13.3.29.31h.72c.17 0 .31-.14.31-.31V7.85c.84-.16 1.58-.67 2.01-1.41 3.43.91 6.12 3.57 7.06 6.99-.8.41-1.36 1.17-1.54 2.05h-2.87c-.16 0-.3.13-.31.29v.72c0 .17.14.31.31.31h2.97c.24.75.77 1.37 1.47 1.72a9.95 9.95 0 0 1-7.11 7.13Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28 29c-.26 0-.51-.1-.71-.29l-5-5a.996.996 0 1 1 1.41-1.41l5 5a.996.996 0 0 1-.71 1.7Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15 27C8.38 27 3 21.62 3 15S8.38 3 15 3s12 5.38 12 12-5.38 12-12 12m0-22C9.49 5 5 9.49 5 15s4.49 10 10 10 10-4.49 10-10S20.51 5 15 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28 29c-.26 0-.51-.1-.71-.29l-5.22-5.22a.996.996 0 1 1 1.41-1.41l5.22 5.22a.996.996 0 0 1-.71 1.7Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15 27C8.38 27 3 21.62 3 15S8.38 3 15 3s12 5.38 12 12-5.38 12-12 12m0-22C9.49 5 5 9.49 5 15s4.49 10 10 10 10-4.49 10-10S20.51 5 15 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15 16.04c-2.49 0-4.52-2.03-4.52-4.52S12.51 7 15 7s4.52 2.03 4.52 4.52-2.03 4.52-4.52 4.52M15 9c-1.39 0-2.52 1.13-2.52 2.52s1.13 2.52 2.52 2.52 2.52-1.13 2.52-2.52S16.39 9 15 9M11 21.53a.999.999 0 0 1-.65-1.76A7.2 7.2 0 0 1 15 18.06c.55 0 1 .45 1 1s-.45 1-1 1c-1.23 0-2.42.44-3.35 1.23-.19.16-.42.24-.65.24"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19 21.53c-.23 0-.46-.08-.65-.24-.93-.8-2.12-1.23-3.35-1.23-.55 0-1-.45-1-1s.45-1 1-1c1.7 0 3.35.61 4.65 1.71a.999.999 0 0 1-.65 1.76"
      })]
    })
  }));
};